import angular from 'angular';

import '../../controller/environment';

angular.module("core.application.main").filter("core_application_main_filter_country_help_url", [
    "core.application.main.controller.environment",
    function(Environment) {
        return function (countryCode) {
            // PAYL-7079 if the country code is given, then the country specific
            // help url will be returned, otherwise it deliberately falls back to
            // using the generic url
            var baseUrl = Environment.HELP_BASE_URL;
            var urls = {
                AU: baseUrl + "/hc/en-au",
                NZ: baseUrl + "/hc/en-nz",
                US: baseUrl + "/hc/en-us",
                GB: baseUrl + "/hc/en-gb",
                CA: baseUrl + "/hc/en-ca",
                ES: baseUrl + "/hc/es-es",
                FR: baseUrl + "/hc/fr-fr",
                IT: baseUrl + "/hc/it-it",
            };
            return urls[countryCode] || baseUrl;
        };
    }
]);
